// iOS ref: client-native/src/features/dictionary/components/dictionaryReviewHighlight.ts
export const DICTIONARY_REVIEW_HIGHLIGHT_TIMEOUT_MS = 3000;
